import classname from "classnames/bind";
import React from "react";
import { EdgeLabelRenderer, getBezierPath } from "reactflow";
import edgeStyle from "../../../styles/pages/flow/boxes/Edge.module.css";
import { CheckEdge, ErrorEdge } from "../../components/Icons";

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  selected,
  label,
}) {
  const cx = classname.bind(edgeStyle);

  const xEqual = sourceX === targetX;
  const yEqual = sourceY === targetY;

  const [edgePath, labelX, labelY] = getBezierPath({
    // we need this little hack in order to display the gradient for a straight line
    sourceX: xEqual ? sourceX + 0.0001 : sourceX,
    sourceY: yEqual ? sourceY + 0.0001 : sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const Yes = label === "Sim" || label === "Tem";
  const No = label === "Não" || label === "Não tem";

  return (
    <>
      <path
        id={id}
        style={style}
        className={cx({ edgePath: true, selected })}
        d={edgePath}
        markerEnd={markerEnd}
      />
      {label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: "absolute",
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              paddingTop: 10,
              paddingBottom: 10,
              paddingLeft: 25,
              paddingRight: 25,
              borderRadius: 15,
              fontSize: 14,
              lineHeight: 1.6,
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              ...(Yes && { backgroundColor: "#1F2625", color: "#82D997" }),
              ...(No && { backgroundColor: "#251F20", color: "#FF502D" }),
            }}
          >
            {Yes && <CheckEdge />}
            {No && <ErrorEdge />}
            <span style={{ marginLeft: 15 }}>{label}</span>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
